import { render, staticRenderFns } from "./ViewResult.vue?vue&type=template&id=83df50b6"
import script from "./ViewResult.vue?vue&type=script&lang=js"
export * from "./ViewResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('83df50b6')) {
      api.createRecord('83df50b6', component.options)
    } else {
      api.reload('83df50b6', component.options)
    }
    module.hot.accept("./ViewResult.vue?vue&type=template&id=83df50b6", function () {
      api.rerender('83df50b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/dynamic_join/ViewResult.vue"
export default component.exports